import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {HttpRequestInformationsModel} from '../../models/http-request/http-request-informations.model';

@Injectable({
  providedIn: 'root',
})
export class HttpRequestService {
  httpRequestTickStart: Subject<HttpRequestInformationsModel> = new Subject<HttpRequestInformationsModel>();
  httpRequestTickEnd: Subject<HttpRequestInformationsModel> = new Subject<HttpRequestInformationsModel>();

  startRequest(request: HttpRequestInformationsModel): void {
    this.httpRequestTickStart.next(request);
  }

  endRequest(request: HttpRequestInformationsModel): void {
    this.httpRequestTickEnd.next(request);
  }
}
